import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/images/img_7.jpg';
const _hoisted_1 = {
  class: "cretaceous-home"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "table",
  "element-loading-text": "Loading Cretaceous Data...",
  "element-loading-background": "rgba(247, 247, 247, 0.8)"
};
const _hoisted_4 = {
  key: 1,
  class: "button-container"
};
import { reactive, ref, onMounted, computed } from 'vue';
import HeaderView from '@/components/HeaderView.vue';
import FooterView from '@/components/footerView.vue';
import { getDataByStratigraphy } from '@/api/index';
import { Cyclostratigraphy } from '@/utils/tableArr';
import { exportExcel } from '@/utils/exportExcel';
import { ElMessage } from 'element-plus';
import axios from 'axios';
export default {
  __name: 'CretaceousHomeView',
  setup(__props) {
    const isLoading = ref(true);
    const showStratigraphy = reactive({
      list: null
    });
    const filteredDataLength = computed(() => showStratigraphy.list?.length || 0);
    let tableArr = reactive({
      list: Cyclostratigraphy
    });

    // 👇 关键修改点 2：添加计算属性，将不需要的三列过滤掉（忽略大小写以防匹配失败）
    const computedColumns = computed(() => {
      const excludeProps = ['comments', 'processed_by', 'reviewed_by'];
      return tableArr.list.filter(item => {
        // 确保 item.prop 存在且转换为小写进行安全匹配
        const propName = item.prop ? item.prop.toLowerCase() : '';
        return !excludeProps.includes(propName);
      });
    });
    const downloadExcel = async () => {
      try {
        // 👇 关键修改点 3：导出 Excel 的时候，也使用过滤后的表头数据
        exportExcel(showStratigraphy.list, computedColumns.value);
        await axios.get('https://test.cyclostrat.org/Cyclic/downloads');
        ElMessage.success('下载成功');
      } catch (error) {
        ElMessage.error('下载失败: ' + error.message);
      }
    };
    const cretaceousEpochs = ['Late Cretaceous', 'Early Cretaceous', 'Cretaceous'];

    // 核心处理函数：过滤并赋值
    const processData = rawData => {
      let baseData = rawData.filter(item => cretaceousEpochs.includes(item.epoch));
      showStratigraphy.list = baseData;
      isLoading.value = false; // 数据处理完毕，关闭动画

      if (baseData.length === 0) {
        ElMessage.info('暂无相关的白垩纪数据记录');
      }
    };
    onMounted(() => {
      const cachedData = sessionStorage.getItem('allStratigraphyData');
      if (cachedData) {
        processData(JSON.parse(cachedData));
      } else {
        getDataByStratigraphy().then(res => {
          sessionStorage.setItem('allStratigraphyData', JSON.stringify(res));
          processData(res);
        }).catch(err => {
          console.error('获取数据失败', err);
          isLoading.value = false;
          ElMessage.error('数据加载失败，请刷新重试');
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_button = _resolveComponent("el-button");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(HeaderView), _createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("p", {
        class: "introduction"
      }, [_createTextVNode(" Welcome to the "), _createElementVNode("span", {
        style: {
          "font-weight": "bold"
        }
      }, "Cyclostratigraphy Database (Cretaceous Sub-database),"), _createTextVNode(" your comprehensive platform for exploring the tast of cyclostratigraphy from Cretaceous! ")], -1)), _cache[3] || (_cache[3] = _createElementVNode("div", {
        style: {
          "text-align": "center"
        }
      }, [_createElementVNode("img", {
        src: _imports_0,
        style: {
          "width": "95%",
          "margin-bottom": "40px",
          "margin-top": "10px"
        },
        alt: "Cretaceous Home Image"
      })], -1)), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [filteredDataLength.value > 0 || !isLoading.value ? (_openBlock(), _createBlock(_component_el_card, {
        key: 0,
        shadow: "hover"
      }, {
        default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "metadata-header"
        }, [_createElementVNode("span", {
          class: "title"
        }, "Cretaceous Data List")], -1)), _createVNode(_component_el_table, {
          data: showStratigraphy.list,
          stripe: "",
          style: {
            "width": "100%"
          },
          height: 750
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedColumns.value, item => {
            return _openBlock(), _createBlock(_component_el_table_column, {
              prop: item.prop,
              label: item.label,
              key: item.label,
              width: item.prop == 'reference' ? 300 : 180,
              fixed: item.prop == 'id'
            }, null, 8, ["prop", "label", "width", "fixed"]);
          }), 128))]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      })) : _createCommentVNode("", true), filteredDataLength.value > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_button, {
        onClick: downloadExcel,
        style: {
          "background-color": "rgb(125,13,85)",
          "color": "white"
        }
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("download")])),
        _: 1
      })])) : _createCommentVNode("", true)])), [[_directive_loading, isLoading.value]])]), _createVNode(FooterView)]);
    };
  }
};